/* eslint-disable camelcase */
/* eslint-disable react/no-unescaped-entities */
import { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import emmaLogo from './../../assets/images/emma-bg.png';
import emmaLogoSmall from './../../assets/images/emma-bg-small.png';
import './../../assets/scss/custom/verify.scss';
import { loaderActions } from '../../features/Loader/LoaderSlice';
import { ConfirmationRequest } from '../../features/Auth/AuthSlice';
import VerificationInput from 'react-verification-input';
import ResendOTPModal from '../../components/auth/ResendOTPModal';

const VerificationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [isResendOPTOpen, setIsResendOPTOpen] = useState(false);

  const [user, setUser] = useState({
    email: searchParams.get('email') !== null ? searchParams.get('email') : '',
    confirmation_code: ''
  });

  const { email, confirmation_code } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const onOTPChange = (otp) => {
    setUser({ ...user, confirmation_code: otp });
  };

  const onEmailChange = (email) => {
    setUser({ ...user, email });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email.trim() === '' || confirmation_code.trim() === '') {
      toast.error('Please fill in all fields', { id: 'verify' });
    } else if (confirmation_code.length < 6) {
      toast.error('OTP Must be 6 digits', { id: 'verify' });
    } else {
      dispatch(loaderActions.show());
      await dispatch(ConfirmationRequest({ email, confirmation_code }));
      dispatch(loaderActions.hide());
    }
  };

  const bgStyleBig = {
    backgroundImage: `url(${emmaLogo})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };
  const bgStyleSmall = {
    backgroundImage: `url(${emmaLogoSmall})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };

  const [matches, setMatches] = useState(window.matchMedia('(min-width: 1220px)').matches);

  useEffect(() => {
    window
      .matchMedia('(min-width: 1220px)')
      .addEventListener('change', (e) => setMatches(e.matches));
    dispatch(loaderActions.hide());
  }, []);

  return (
    <>
      <Container fluid className="verify-page" style={matches ? bgStyleBig : bgStyleSmall}>
        {isResendOPTOpen === true && (
          <ResendOTPModal
            setIsOpen={setIsResendOPTOpen}
            isOpen={isResendOPTOpen}
            onEmailChange={onEmailChange}
          />
        )}
        <Row>
          {matches ? <Col className="verify-col banner" sm={4}></Col> : null}
          <Col className="verify-col form" sm={8}>
            <Form>
              <Form.Group className="align-items-center ">
                <Form.Row className="logo-row mb-5 ml-5">
                  <p className="verify-form-header">EVP Account Verification</p>
                </Form.Row>
                <Form.Group className="verify-form align-items-center  ">
                  <Form.Row>
                    <label className="text-label"> E-mail Address:</label>
                    <Form.Control
                      className="text-normal"
                      size="lg"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="E-mail Address"
                      value={email}
                      onChange={onChange}
                      required
                      autoComplete="email"
                    />
                  </Form.Row>
                  <Form.Row className="mt-4">
                    <label className="text-label"> OTP:</label>
                  </Form.Row>
                  <Form.Row className="mt-2">
                    <VerificationInput
                      validChars="0-9"
                      inputProps={{ inputMode: 'numeric' }}
                      value={confirmation_code}
                      onChange={onOTPChange}
                    />
                  </Form.Row>
                  <Form.Row className="mt-4" color="#1E2B5A">
                    <Button
                      variant="primary"
                      className="btn btn-block text-normal"
                      style={{ backgroundColor: '#1E2B5A', borderRadius: '5px' }}
                      type="submit"
                      onClick={onSubmit}
                      block
                    >
                      Verify Now
                    </Button>
                  </Form.Row>
                  <br />
                  <Form.Row className=" mt-2 " color="#1E2B5A">
                    <p className="mb-0 text-white">
                      Already Verified?{' '}
                      <Button variant="link" onClick={() => navigate('/login')}>
                        Login Now
                      </Button>
                    </p>
                  </Form.Row>
                  <Form.Row className=" mt-2 " color="#1E2B5A">
                    <p className="mb-0 text-white">
                      OTP lost or expired?
                      <Button variant="link" onClick={() => setIsResendOPTOpen(true)}>
                        Request new code
                      </Button>
                    </p>
                  </Form.Row>
                </Form.Group>
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default VerificationPage;
